export enum ShipmentEventType {
  DELIVERY_STATUS = 'DELIVERY_STATUS',
  CONTRACT = 'CONTRACT',
  CONFIRMATION = 'CONFIRMATION',
  PAYMENT = 'PAYMENT',
  LITIGATION = 'LITIGATION',
}
